import {
  COMPARE_PREFIX,
  COMPARE_SUFFIX,
  COMPARE_TOTALS_SUFFIX,
  TOTALS_SUFFIX,
} from './column-keys';
import { ERowReaderMode } from '../types';

export const ROW_READER_MODE_CONFIG: Record<ERowReaderMode, { prefix: string; suffix: string }> = {
  [ERowReaderMode.DEFAULT]: { prefix: '', suffix: '' },
  [ERowReaderMode.COMPARISON]: { prefix: COMPARE_PREFIX, suffix: COMPARE_SUFFIX },
  [ERowReaderMode.TOTALS]: { prefix: '', suffix: TOTALS_SUFFIX },
  [ERowReaderMode.COMPARISON_TOTALS]: { prefix: COMPARE_PREFIX, suffix: COMPARE_TOTALS_SUFFIX },
  [ERowReaderMode.GROUP_TOTALS]: { prefix: '', suffix: TOTALS_SUFFIX },
};
